// @flow
import { defineMessages } from 'react-intl';

export default defineMessages({
    // Category
    comfort: {
        id: 'actions.comfort',
        defaultMessage: 'Comfort'
    },
    reassurance: {
        id: 'actions.reassurance',
        defaultMessage: 'Reassurance'
    },
    efficiency: {
        id: 'actions.efficiency',
        defaultMessage: 'Efficiency'
    },
    // Devices
    heating: {
        id: 'actions.heating',
        defaultMessage: 'Heating'
    },
    light: {
        id: 'actions.light',
        defaultMessage: 'Bulb'
    },
    plug: {
        id: 'actions.plug',
        defaultMessage: 'Plug'
    },
    motion: {
        id: 'actions.motion',
        defaultMessage: 'Motion'
    },
    naThermostat: {
        id: 'actions.na-thermostat',
        defaultMessage: 'Thermostat'
    },
    contact: {
        id: 'actions.contact',
        defaultMessage: 'Win/Door'
    },
    button: {
        id: 'actions.button',
        defaultMessage: 'Hive Button'
    },
    quickAction: {
        id: 'actions.quick-action',
        defaultMessage: 'Quick Action'
    },
    quickActionChosen: {
        id: 'actions.quick-action-chosen',
        defaultMessage: 'Quick Action tapped'
    },
    quickActionDescription: {
        id: 'actions.quick-action-description',
        defaultMessage: 'Trigger this action from your dashboard'
    },
    // attributes
    heatingAttribute: {
        id: 'actions.heating-attribute',
        defaultMessage: 'Heating'
    },
    hotwaterAttribute: {
        id: 'actions.hotwater-attribute',
        defaultMessage: 'Hot Water'
    },
    bulbAttribute: {
        id: 'actions.bulb-attribute',
        defaultMessage: 'Active Light'
    },
    plugAttribute: {
        id: 'actions.plug-attribute',
        defaultMessage: 'Active Plug'
    },
    motionAttribute: {
        id: 'actions.motion-attribute',
        defaultMessage: 'Motion Sensor'
    },
    winDoorAttribute: {
        id: 'actions.win-door-attribute',
        defaultMessage: 'Window/Door Sensor'
    },
    notificationsAttribute: {
        id: 'actions.notifications-attribute',
        defaultMessage: 'Notifications'
    },
    notifyMe: {
        id: 'actions.notify-me',
        defaultMessage: 'Notify me'
    },
    notifyPush: {
        id: 'actions.notify-push',
        defaultMessage: 'Push'
    },
    notifyEmail: {
        id: 'actions.notify-email',
        defaultMessage: 'Email'
    },
    notifyText: {
        id: 'actions.notify-text',
        defaultMessage: 'Text'
    },
    scheduleAttribute: {
        id: 'actions.schedule-attribute',
        defaultMessage: 'Schedule'
    },
    betweenTheseTimes: {
        id: 'actions.between-these-times',
        defaultMessage: 'Between these times'
    },
    darkAttribute: {
        id: 'actions.dark-attribute',
        defaultMessage: 'Dark Outside'
    },
    humidityAttribute: {
        id: 'actions.humidity-attribute',
        defaultMessage: 'Humidity'
    },
    naThermostatAttribute: {
        id: 'actions.na-thermostat-attribute',
        defaultMessage: 'Thermostat'
    },
    quickActionAttribute: {
        id: 'actions.quick-action-attribute',
        defaultMessage: 'Quick Action'
    },
    senseAttribute: {
        id: 'actions.sense-attribute',
        defaultMessage: 'Sense'
    },
    sunriseSunsetAttribute: {
        id: 'actions.sunrise-sunset-attribute',
        defaultMessage: 'Sunrise Sunset'
    },
    temperatureAttribute: {
        id: 'actions.temperature-attribute',
        defaultMessage: 'Temperature'
    },
    cameraAttribute: {
        id: 'actions.camera-attribute',
        defaultMessage: 'View'
    },
    // select labels
    forDuration: {
        id: 'actions.for-duration',
        defaultMessage: 'For duration'
    },
    chooseSensor: {
        id: 'actions.choose-sensor',
        defaultMessage: 'Choose Sensor'
    },
    whenSensor: {
        id: 'actions.when-sensor',
        defaultMessage: 'When the sensor'
    },
    chooseZone: {
        id: 'actions.choose-zone',
        defaultMessage: 'Choose Zone'
    },
    whenTemperature: {
        id: 'actions.when-temperature',
        defaultMessage: 'When temperature'
    },
    whenHumidity: {
        id: 'actions.when-humidity',
        defaultMessage: 'When humidity'
    },
    whenSunriseSunset: {
        id: 'actions.when-sunrise-sunset',
        defaultMessage: 'When'
    },
    sunrisePreference: {
        id: 'actions.sunrise-preference',
        defaultMessage: 'Sunrise preference'
    },
    sunsetPreference: {
        id: 'actions.sunset-preference',
        defaultMessage: 'Sunset preference'
    },
    choosePlug: {
        id: 'actions.choose-plug',
        defaultMessage: 'Choose plug'
    },
    setTo: {
        id: 'actions.set-to',
        defaultMessage: 'Set to'
    },
    setTargetTo: {
        id: 'actions.set-target-to',
        defaultMessage: 'Set target to'
    },
    quickCool: {
        id: 'actions.quick-cool',
        defaultMessage: 'Quick Cool'
    },
    quickHeat: {
        id: 'actions.quick-heat',
        defaultMessage: 'Quick Heat'
    },
    chooseView: {
        id: 'actions.choose-view',
        defaultMessage: 'Choose View'
    },
    turnView: {
        id: 'actions.turn-view',
        defaultMessage: 'Turn View monitoring'
    },
    cameraOn: {
        id: 'actions.camera-on',
        defaultMessage: 'On'
    },
    cameraOff: {
        id: 'actions.camera-off',
        defaultMessage: 'Off'
    },
    // select values label
    durationStayOn: {
        id: 'actions.duration-stay-on',
        defaultMessage: 'Stay on'
    },
    durationStayOff: {
        id: 'actions.duration-stay-off',
        defaultMessage: 'Stay off'
    },
    duration30Seconds: {
        id: 'actions.duration-30-seconds',
        defaultMessage: '30 seconds'
    },
    duration1Minute: {
        id: 'actions.duration-1-minute',
        defaultMessage: '1 minute'
    },
    duration3Minutes: {
        id: 'actions.duration-3-minutes',
        defaultMessage: '3 minutes'
    },
    duration5Minutes: {
        id: 'actions.duration-5-minutes',
        defaultMessage: '5 minutes'
    },
    duration10Minutes: {
        id: 'actions.duration-10-minutes',
        defaultMessage: '10 minutes'
    },
    duration15Minutes: {
        id: 'actions.duration-15-minutes',
        defaultMessage: '15 minutes'
    },
    duration30Minutes: {
        id: 'actions.duration-30-minutes',
        defaultMessage: '30 minutes'
    },
    duration1Hour: {
        id: 'actions.duration-1-hour',
        defaultMessage: '1 hour'
    },
    duration2Hours: {
        id: 'actions.duration-2-hours',
        defaultMessage: '2 hours'
    },
    duration3Hours: {
        id: 'actions.duration-3-hours',
        defaultMessage: '3 hours'
    },
    duration4Hours: {
        id: 'actions.duration-4-hours',
        defaultMessage: '4 hours'
    },
    duration5Hours: {
        id: 'actions.duration-5-hours',
        defaultMessage: '5 hours'
    },
    duration6Hours: {
        id: 'actions.duration-6-hours',
        defaultMessage: '6 hours'
    },
    constactSensorOpens: {
        id: 'actions.constact-sensor-opens',
        defaultMessage: 'Opens'
    },
    constactSensorCloses: {
        id: 'actions.constact-sensor-closes',
        defaultMessage: 'Closes'
    },
    temperatureBelow: {
        id: 'actions.temperature-below',
        defaultMessage: 'Falls below'
    },
    temperatureAbove: {
        id: 'actions.temperature-above',
        defaultMessage: 'Rises above'
    },
    sunrise: {
        id: 'actions.sunrise',
        defaultMessage: 'Sunrise'
    },
    sunset: {
        id: 'actions.sunset',
        defaultMessage: 'Sunset'
    },
    atSunrise: {
        id: 'actions.at-sunrise',
        defaultMessage: 'At sunrise'
    },
    atSunset: {
        id: 'actions.at-sunset',
        defaultMessage: 'At sunset'
    },
    offset1HourBefore: {
        id: 'actions.offset-1-hour-before',
        defaultMessage: '1 hour before'
    },
    offset50MinutesBefore: {
        id: 'actions.offset-50-minutes-before',
        defaultMessage: '50 minutes before'
    },
    offset40MinutesBefore: {
        id: 'actions.offset-40-minutes-before',
        defaultMessage: '40 minutes before'
    },
    offset30MinutesBefore: {
        id: 'actions.offset-30-minutes-before',
        defaultMessage: '30 minutes before'
    },
    offset20MinutesBefore: {
        id: 'actions.offset-20-minutes-before',
        defaultMessage: '20 minutes before'
    },
    offset10MinutesBefore: {
        id: 'actions.offset-10-minutes-before',
        defaultMessage: '10 minutes before'
    },
    offset10MinutesAfter: {
        id: 'actions.offset-10-minutes-after',
        defaultMessage: '10 minutes after'
    },
    offset20MinutesAfter: {
        id: 'actions.offset-20-minutes-after',
        defaultMessage: '20 minutes after'
    },
    offset30MinutesAfter: {
        id: 'actions.offset-30-minutes-after',
        defaultMessage: '30 minutes after'
    },
    offset40MinutesAfter: {
        id: 'actions.offset-40-minutes-after',
        defaultMessage: '40 minutes after'
    },
    offset50MinutesAfter: {
        id: 'actions.offset-50-minutes-after',
        defaultMessage: '50 minutes after'
    },
    offset1HourAfter: {
        id: 'actions.offset-1-hour-after',
        defaultMessage: '1 hour after'
    },
    choosePeriod: {
        id: 'actions.choose-period',
        defaultMessage: 'Choose period'
    },
    darkOutside: {
        id: 'actions.dark-outside',
        defaultMessage: 'Dark Outside'
    },
    lightOutside: {
        id: 'actions.light-outside',
        defaultMessage: 'Light Outside'
    },
    from: {
        id: 'actions.from',
        defaultMessage: 'From'
    },
    until: {
        id: 'actions.until',
        defaultMessage: 'Until'
    },
    offset1HourBeforeSunset: {
        id: 'actions.offset-1-hour-before-sunset',
        defaultMessage: '1 hour before sunset'
    },
    offset1HourAfterSunset: {
        id: 'actions.offset-1-hourAfterSunset',
        defaultMessage: '1 hour after sunset'
    },
    offsetMinutesBeforeSunset: {
        id: 'actions.offset-minutes-before-sunset',
        defaultMessage: '{numMinutes} {numMinutes, plural, one {minute} other {minutes}} before sunset'
    },
    offsetMinutesAfterSunset: {
        id: 'actions.offset-minutes-after-sunset',
        defaultMessage: '{numMinutes} {numMinutes, plural, one {minute} other {minutes}} after sunset'
    },
    offset1HourBeforeSunrise: {
        id: 'actions.offset-1-hour-before-sunrise',
        defaultMessage: '1 hour before sunrise'
    },
    offset1HourAfterSunrise: {
        id: 'actions.offset-1-hour-after-sunrise',
        defaultMessage: '1 hour after sunrise'
    },
    offsetMinutesBeforeSunrise: {
        id: 'actions.offset-minutes-before-sunrise',
        defaultMessage: '{numMinutes} {numMinutes, plural, one {minute} other {minutes}} before sunrise'
    },
    offsetMinutesAfterSunrise: {
        id: 'actions.offset-minutes-after-sunrise',
        defaultMessage: '{numMinutes} {numMinutes, plural, one {minute} other {minutes}} after sunrise'
    },
    turnPlug: {
        id: 'actions.turn-plug',
        defaultMessage: 'Turn plug'
    },
    plugOn: {
        id: 'actions.plug-on',
        defaultMessage: 'On'
    },
    plugOff: {
        id: 'actions.plug-off',
        defaultMessage: 'Off'
    },
    turnLight: {
        id: 'actions.turn-light',
        defaultMessage: 'Turn light'
    },
    lightOn: {
        id: 'actions.light-on',
        defaultMessage: 'On'
    },
    lightOff: {
        id: 'actions.light-off',
        defaultMessage: 'Off'
    },
    atBrightness: {
        id: 'actions.at-brightness',
        defaultMessage: 'At brightness'
    },
    lastUsedBrightness: {
        id: 'actions.last-used-brightness',
        defaultMessage: 'Last used brightness'
    },
    heatingSchedule: {
        id: 'actions.heating-schedule',
        defaultMessage: 'Schedule'
    },
    heatingManual: {
        id: 'actions.heating-manual',
        defaultMessage: 'Manual'
    },
    heatingOff: {
        id: 'actions.heating-off',
        defaultMessage: 'Off'
    },
    heatingBoost: {
        id: 'actions.heating-boost',
        defaultMessage: 'Boost'
    },
    hotWaterManual: {
        id: 'actions.hot-water-manual',
        defaultMessage: 'On'
    }
});



// WEBPACK FOOTER //
// ./src/core/constants/actions/intl.js